<template>
  <div>
    <span v-for="(r, i) in row" :key="i">{{ display(r) }}<span v-if="i !== row.length - 1"> + </span></span>
    <span v-if="checkCurrencies()"> = <br />{{ sum(row) }}</span>
  </div>
</template>

<script>
import {calculateTotalWithOptional} from '../utils'

export default {
  name: 'CalcRatesTableCellTotal',
  props: {
    row: {
      type: Array,
      required: true
    },
    selectedOptionalTypes: {
      type: Array,
      default: () => []
    },
    currency: {
      type: String,
      default: null
    }
  },
  methods: {
    display (r) {
      const amount = calculateTotalWithOptional(
        r,
        {selectedOptionalTypes: this.selectedOptionalTypes, currency: this.currency})
      const currency = this.currency || r.rateData.rate.currency
      return `${amount.toFixed(2)} ${currency}`
    },
    sum (row) {
      const currency = this.currency || row[0].rateData.rate.currency
      const sum = row.reduce((acc, r) => {
        const amount = calculateTotalWithOptional(
          r,
          {selectedOptionalTypes: this.selectedOptionalTypes, currency: this.currency}
        )
        return acc + amount
      }, 0.0)
      return `${sum.toFixed(2)} ${currency}`
    },
    checkCurrencies () {
      if (this.currency) {
        return true
      }
      let isSame = true
      let curr = this.row[0].rateData.rate.currency
      this.row.forEach(r => {
        isSame = r.rateData.rate.currency === curr
      })
      return this.row.length > 1 && isSame
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcRatesTableCellTotal.vue